import React, { useState, useEffect } from 'react';
import Card from 'screens/shared/card-basic';
import { useSelector } from 'react-redux';
import {
  _t, hasKeys, getUnattachedVolumes,
} from 'utils';
import { actions, ACTIONS_TYPES } from 'redux/local';
import Utils from 'screens/shared/utilities';
import Text from './input-field';

export default ({
  onChange = null,
  dcId = '',
  error = '',
}) => {
  const { [ACTIONS_TYPES.DATA_CENTER.GET]: datacenter = {} } = useSelector((e) => e);

  const [items, setItems] = useState([]);
  const [filters, setFilers] = useState({
    search: '',
  });

  useEffect(() => {
    if (hasKeys(datacenter)) {
      const volumes = getUnattachedVolumes(datacenter);
      setItems([...volumes]);
    } else if (dcId) {
      actions.dataCenter.get({ id: dcId });
    }
  }, [datacenter, dcId]);

  const setFilter = (valueParam) => setFilers((e) => ({ ...e, ...valueParam }));

  const onItemSelect = (item) => {
    item.isSelected = true;
    const updatedItems = items.map((e) => ({ ...e, isSelected: false }));
    const index = updatedItems.findIndex(({ id }) => id === item.id);
    updatedItems[index] = item;
    setItems([...updatedItems]);
    onChange(item);
  };

  let filteredItems = items;

  if (filters.search) {
    filteredItems = filteredItems
      .filter((
        { properties: { name = '' } },
      ) => (name.toLowerCase().indexOf(filters.search.toLowerCase()) !== -1));
  }

  return (
    <>
      <div className="image-selector" style={error ? { border: '1px solid var(--color-danger)' } : {}}>
        <div className="image-selector-top">
          <Text
            label={_t('Search')}
            value={filters.search}
            onChange={(valueParam) => setFilter({ search: valueParam })}
          />
        </div>

        <div className="cards">
          {filteredItems.map((item) => {
            const {
              id, properties: { name, size, type }, isSelected = false,
            } = item;
            return (
              <Card
                key={id}
                className={!!isSelected && 'selected'}
                onClick={() => onItemSelect(item)}
                icon="hdd"
                iconText={type}
                title={name}
                details={`${size} GB`}
                buttons={[]}
                isArrow={false}
              />
            );
          })}
          {(!!filters.search) && !filteredItems.length && <Utils.NoData />}
          {!items.length && <Utils.NoData />}
        </div>
      </div>
      { error && <span style={{ color: 'var(--color-danger)' }}>{error}</span>}
    </>
  );
};
